import instance from './BaseAPI';
import * as AWS from '../constants/AWS';
import { CONFIRM_WAIT_TIME, CONFIRM_RETRY_MAX_CNT } from '../constants/Institution';

let api = instance.Api;

/**
 * 施設新規登録.
 *
 * @export
 * @param {*} institutionCareId アカウントID
 * @param {*} password パスワード.
 * @param {*} attributeList
 * @param {*} requestFunc
 * @param {*} fetchedFunc
 * @returns
 */
export function signUp(
  institutionCareId, password, attributeList,
  requestFunc, fetchedFunc) {
  return dispatch => {
    dispatch(requestFunc());

    AWS.institutionPool.signUp(
      institutionCareId,
      password,
      attributeList,
      null,
      (err, result) => {
        if (err) {
          dispatch(fetchedFunc(false, err));
        } else {
          dispatch(fetchedFunc(true, result));
        }
      }
    );
  }
}

/**
 * リトライの仕組み.
 *
 * @param {*} dispatch
 * @param {*} fetchedFunc
 * @param {*} func
 * @param {*} retryCount 試行回数.
 * @param {*} waitTime 待ち時間.
 */
function retryable(dispatch, fetchedFunc, func, retryCount, waitTime) {
  func().then(
    // いきなり成功.
    response => dispatch(fetchedFunc(true, response.data))
  ).catch(
    err => {
      let count = retryCount
      count--;
      if(retryCount === 1) {
        // 失敗数が限界.
        dispatch(fetchedFunc(false, err))
      } else {
        // まだ実行可能(再帰的).
        setTimeout(
          () => { retryable(dispatch, fetchedFunc, func, count, waitTime)},
          waitTime
        );
      }
    }
  );
}

/**
 * 施設新規登録(confirm).
 *
 * @export
 * @param {*} institutionSub
 * @param {*} requestFunc
 * @param {*} fetchedFunc
 * @returns
 */
export function confirm(institutionSub, requestFunc, fetchedFunc) {
  return dispatch => {
    dispatch(requestFunc());

    retryable(dispatch, fetchedFunc,
      // AxiousInstanceを返す.
      () => { return api.post('/admin/institutions/' + institutionSub + '/confirm')},
      CONFIRM_RETRY_MAX_CNT,
      CONFIRM_WAIT_TIME
    );
  }
}



// WEBPACK FOOTER //
// ./src/api/InstitutionCognito.js